import { ReactElement } from 'react';
import { StyledAccordion, StyledAccordionDetails, StyledAccordionSummary } from 'hooks/StyledComponents';
import { Field, useFormikContext } from 'formik';
import uniqueId from 'lodash/uniqueId';

// Components
import DatePicker from 'components/DatePicker/DatePicker';

// Types
import { IFacetProps, SearchRequest } from '../../../types';

export const Date = (props: IFacetProps): ReactElement => {
  const { facet, isDisabled, isExpanded, expandIcon, onToggleExpand } = props;
  const { values } = useFormikContext<SearchRequest>();
  const { displayValue, payloadEndValue, payloadStartValue } = facet;

  const minDate = values?.[payloadStartValue];
  const maxDate = values?.[payloadEndValue];

  return (
    <StyledAccordion key={displayValue} expanded={isExpanded} onChange={onToggleExpand}>
      <StyledAccordionSummary expandIcon={expandIcon} id={uniqueId()}>
        {displayValue}
      </StyledAccordionSummary>
      <StyledAccordionDetails>
        <div className="eyebrow">From: </div>
        <Field name={payloadStartValue}>
          {({ field }) => (
            <DatePicker
              disabled={isDisabled}
              field={field}
              formikKey={payloadStartValue}
              maxDate={maxDate}
              timeOfDay="midnight"
            />
          )}
        </Field>

        <div className="eyebrow">To: </div>
        <Field name={payloadEndValue}>
          {({ field }) => (
            <DatePicker
              disabled={isDisabled}
              field={field}
              formikKey={payloadEndValue}
              minDate={minDate}
              timeOfDay="endOfDay"
            />
          )}
        </Field>
      </StyledAccordionDetails>
    </StyledAccordion>
  );
};
